import React, { useCallback } from 'react';
import ReactTooltip from 'react-tooltip';
import {Environment} from '../../../../const/environment';
import ProjectHeaderButton from '../ProjectHeader/ProjectHeaderButton';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/projects/actions.projects';
import { confirmAlert } from '../../../../services/mini/alanConfirmAlert';
import NewProjectTagForm from '../NewProjectTagForm/NewProjectTagForm';
import SaveToLastConfirmPopup from '../SaveToLastConfirmPopup/SaveToLastConfirmPopup';
import projectHelper from '../../../../services/ProjectHelper';
import getEnvironment from '../../../../services/mini/getEnvironment';
import _ from 'lodash';
import ProjectTagSelector from '../ProjectTagSelector/ProjectTagSelector';

function CreateOrSwitchToLastTagBtn({ project, environment, scriptName, createProjectTag, tier, makeScriptsEditable }) {
  const projectName = project.name;
  const selectedTagId = project[`${environment}TagId`];
  const selectedTag = _.find(project.tags, { tagId: selectedTagId });
  const isLast =
    selectedTag &&
    selectedTag.message &&
    selectedTag.message.toLowerCase() === 'last';
  const hasSelectedTag =
    project && project.tags && project.tags.length > 0 && selectedTagId;

  const hasScripts = () => {
    if (project && project.scripts && project.scripts.length > 0) {
      return true;
    }
    return false;
  };

  const createNewProjectTagCb = useCallback(() => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <NewProjectTagForm
            tier={tier}
            project={project}
            environment={environment}
            createProjectTag={createProjectTag}
            onClose={onClose}
          />
        );
      },
    });
  }, [tier, project, environment, createProjectTag]);

  const saveToLastCb = useCallback(() => {
    const currentTagName = projectHelper.getTagName(
      project,
      getEnvironment(environment)
    );

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <SaveToLastConfirmPopup
            makeScriptsEditable={makeScriptsEditable}
            oldVersion={currentTagName}
            project={project}
            onClose={onClose}
          />
        );
      },
    });
  }, [environment, makeScriptsEditable, project]);

  return hasSelectedTag ? (
    <React.Fragment>
      <ReactTooltip id="createNewVersionBtn" />
      {environment === Environment.Staging && (
        <React.Fragment>
          {isLast ? (
            <div
              data-for="createNewVersionBtn"
              data-tip={
                !hasScripts() ? 'Add at least one script first' : ''
              }
            >
              <ProjectHeaderButton
                className={`project-header_version-action  ${
                  !(hasScripts() && projectName && scriptName) &&
                  'disabled'
                }`}
                id="saveAsNewVersionTooltip"
                tip="Save as New Version"
                tooltipClass="save-new-version-tooltip"
                onClick={createNewProjectTagCb}
                iconClass="icon-alan-save-as-new-version"
              />
            </div>
          ) : (
            <ProjectHeaderButton
              className="project-header_version-action not-last"
              id="saveToLastVersionTooltip"
              tip="Save to Last Version"
              tooltipClass="save-to-last-version-tooltip"
              onClick={saveToLastCb}
              iconClass="icon icon-alan-save-to-last-version"
            />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  ) : (
    <React.Fragment />
  );
}

function mapStateToProps({ projectsInfo, user }, ownProps) {
  const scriptName = ownProps.scriptName;
  return {
    project: projectsInfo.currentProject,
    tier: user.tier,
    userEmail: user.email,
    scriptName,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createProjectTag: (param) =>
      asyncDispatch(actions.addProjectTag, dispatch, param),
    makeScriptsEditable: (project, tagId, lastTagId) =>
      dispatch(actions.makeScriptsEditable(project, tagId, lastTagId)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateOrSwitchToLastTagBtn);
